import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        review: '='
    },
    template: `
        <div class="heading01"><h2>{{ 'performanceReview.Employee results and goals' | translate }}</h2></div>
        <h3>{{ 'performanceReview.previous period results analysis' | translate }}</h3>
        <table class="data01 fixed">
            <colgroup>
                <col width="20%"/>
                <col width="45%"/>
                <col width="15%"/>
                <col width="15%"/>
                <col width="5%"/>
            </colgroup>
            <thead>
                <tr>
                    <th ng-if="vm.isDefaultLayout">{{ 'performanceReview.Agreed purpose' | translate }}</th>
                    <th ng-if="!vm.isDefaultLayout">{{ 'performanceReview.Activity' | translate }}</th>
                    <th ng-if="vm.isDefaultLayout">{{ 'performanceReview.Result' | translate }}</th>
                    <th ng-if="!vm.isDefaultLayout">{{ 'performanceReview.Results analysis' | translate }}</th>
                    <th>{{ 'performanceReview.Employee comment' | translate }}</th>
                    <th>{{ 'performanceReview.Direct manager comment' | translate }}</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="row in vm.review.results">
                    <td>
                        <textarea
                            class="form-control print-hide"
                            ng-model="row.agreedObjective"
                            ng-readOnly="vm.review.isReadOnly"
                            ng-disabled="vm.review.isReadOnly"
                        ></textarea>
                        <span class="print-only">{{row.action}}</span>
                    </td>
                    <td>
                        <textarea
                            class="form-control print-hide"
                            ng-model="row.analyze"
                            ng-readOnly="vm.review.isReadOnly"
                            ng-disabled="vm.review.isReadOnly"
                        ></textarea>
                        <span class="print-only">{{row.analyze}}</span>
                    </td>
                    <td>
                        <textarea
                            class="form-control print-hide"
                            ng-model="row.employeeComment"
                            ng-readOnly="vm.review.isReadOnly || vm.review.isManager"
                            ng-disabled="vm.review.isReadOnly || vm.review.isManager"
                        ></textarea>
                        <span class="print-only">{{row.employeeComment}}</span>
                    </td>
                    <td>
                        <textarea
                            class="form-control print-hide"
                            ng-model="row.managerComment"
                            ng-readOnly="vm.review.isReadOnly || !vm.review.isManager"
                            ng-disabled="vm.review.isReadOnly || !vm.review.isManager"
                        ></textarea>
                        <span class="print-only">{{row.managerComment}}</span>
                    </td>
                    <td>
                        <a
                            class="btn notext ico-delete"
                            ng-if="!vm.review.isReadOnly && !vm.review.isManager"
                            ng-click="vm.deleteRow(vm.review.results, $index)">
                                {{ 'general.Delete' | translate }}
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <ul class="actions01" ng-if="!vm.review.isReadOnly">
            <li class="primary"><a class="btn add" ng-click="vm.addRow(vm.review.results)">{{ 'general.Add row' | translate }}</a></li>
        </ul>
        <hr>
        <h3>{{ 'performanceReview.Next period work goals' | translate }}</h3>
        <table class="data01 fixed">
            <colgroup>
                <col width="20%"/>
                <col width="45%"/>
                <col width="15%"/>
                <col width="15%"/>
                <col width="5%"/>
            </colgroup>
            <thead>
            <tr>
                <th>{{ 'performanceReview.Goal' | translate }}</th>
                <th>{{ 'performanceReview.Excepted result' | translate }}</th>
                <th>{{ 'performanceReview.Deadline' | translate }}</th>
                <th>{{ 'performanceReview.Comments' | translate }}</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr ng-repeat="row in vm.review.goals">
                <td>
                    <textarea
                        class="form-control print-hide"
                        ng-model="row.objective"
                        ng-readOnly="vm.review.isReadOnly"
                        ng-disabled="vm.review.isReadOnly"
                    ></textarea>
                    <span class="print-only">{{row.objective}}</span>
                </td>
                <td>
                    <textarea
                        class="form-control print-hide"
                        ng-model="row.expectedResult"
                        ng-readOnly="vm.review.isReadOnly"
                        ng-disabled="vm.review.isReadOnly"
                    ></textarea>
                    <span class="print-only">{{row.expectedResult}}</span>
                </td>
                <td>
                    <datepicker-api
                        ng-model="row.deadline"
                        ng-disabled="vm.review.isReadOnly"></datepicker-api>
                </td>
                <td>
                    <textarea
                        class="form-control print-hide"
                        ng-model="row.managerComment"
                        ng-readOnly="vm.review.isReadOnly || !vm.review.isManager"
                        ng-disabled="vm.review.isReadOnly || !vm.review.isManager"
                    ></textarea>
                    <span class="print-only">{{row.managerComment}}</span>
                </td>
                <td>
                    <a
                        class="btn notext ico-delete"
                        ng-if="!vm.review.isReadOnly && !vm.review.isManager"
                        ng-click="vm.deleteRow(vm.review.goals, $index)">
                            {{ 'general.Delete' | translate }}
                    </a>
                </td>
            </tr>
            </tbody>
        </table>
        <ul class="actions01" ng-if="!vm.review.isReadOnly">
            <li class="primary"><a class="btn add" ng-click="vm.addRow(vm.review.goals)">{{ 'general.Add row' | translate }}</a></li>
        </ul>
    `
})
export default class {
    constructor ($q, $scope, ReviewResource, REVIEW_LAYOUT_ENUM) {
        this.$q = $q;
        this.$scope = $scope;
        this.ReviewResource = ReviewResource;
        this.REVIEW_LAYOUT_ENUM = REVIEW_LAYOUT_ENUM;
        $scope.$on('review:save', () => this.save());
    }

    $onInit () {
        if (this.review.results.length === 0) {
            this.review.results.push(this.getEmptyRow());
        }
        if (this.review.goals.length === 0) {
            this.review.goals.push(this.getEmptyRow());
        }
        this.isDefaultLayout = this.review.form.layoutType === this.REVIEW_LAYOUT_ENUM.DEFAULT;
    }

    addRow (rows) {
        rows.push(this.getEmptyRow());
    }

    deleteRow (rows, index) {
        rows.splice(index, 1);
    }

    getEmptyRow () {
        return { reviewId: this.review.id };
    }

    save () {
        const params = { guid: this.review.guid };
        this.$q.all({
            results: this.ReviewResource.setResults(params, this.review.results).$promise,
            goals: this.ReviewResource.setGoals(params, this.review.goals).$promise
        })
            .then((response) => {
                this.review.results = response.results;
                this.review.goals = response.goals;
                this.$scope.$emit('review:save:success');
            })
            .catch(() => this.$scope.$emit('review:save:error'));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/review/default/resultsAndGoals/index.js